import * as React from 'react';

import { IJsonQueryInfrastructureParams } from '../../../../json_query';
import { getInfrastructureParamChangedAction } from '../../../state/advanced/infrastructure';
import { Column, ColumnsContainer, Row } from '../markup';
import { getCheckboxParam } from './abstract_params/checkbox_param';

const style = require('../index.css');

export type TInfrastructureParamName = keyof IJsonQueryInfrastructureParams;
export type TInfrastructureParam = { name: string; jqParamName: TInfrastructureParamName };

export const TInfrastructureParams: { [key: string]: TInfrastructureParam } = {
  CarWash: { name: 'Автомойка', jqParamName: 'infrastructure_has_car_wash' },
  CarService: { name: 'Автосервис', jqParamName: 'infrastructure_has_car_service' },
  Pharmacy: { name: 'Аптека', jqParamName: 'infrastructure_has_pharmacy' },
  ClothesStudio: { name: 'Ателье одежды', jqParamName: 'infrastructure_has_clothes_studio' },
  ATM: { name: 'Банкомат', jqParamName: 'infrastructure_has_atm' },
  Pool: { name: 'Бассейн', jqParamName: 'infrastructure_has_pool' },
  Buffet: { name: 'Буфет', jqParamName: 'infrastructure_has_buffet' },

  WarehouseComplex: {
    name: 'Выставочно-складской комплекс',
    jqParamName: 'infrastructure_has_exhibition_and_warehouse_complex',
  },

  Hotel: { name: 'Гостиница', jqParamName: 'infrastructure_has_hotel' },

  Cafe: { name: 'Кафе', jqParamName: 'infrastructure_has_cafe' },
  Cinema: { name: 'Кинотеатр', jqParamName: 'infrastructure_has_cinema' },
  ConferenceRoom: { name: 'Конференц-зал', jqParamName: 'infrastructure_has_conference_room' },
  MedicalCenter: { name: 'Медицинский центр', jqParamName: 'infrastructure_has_medical_center' },
  Minimarket: { name: 'Минимаркет', jqParamName: 'infrastructure_has_minimarket' },
  NotaryOffice: { name: 'Нотариальная контора', jqParamName: 'infrastructure_has_notary_office' },
  Department: { name: 'Отделение банка', jqParamName: 'infrastructure_has_bank_department' },
  Park: { name: 'Парк', jqParamName: 'infrastructure_has_park' },
  Restaraunt: { name: 'Ресторан', jqParamName: 'infrastructure_has_restaurant' },

  BeautyShop: { name: 'Салон красоты', jqParamName: 'infrastructure_has_beauty_shop' },
  Warehouse: { name: 'Складские помещения', jqParamName: 'infrastructure_has_warehouse' },
  Canteen: { name: 'Столовая', jqParamName: 'infrastructure_has_canteen' },
  Supermarket: { name: 'Супермаркет', jqParamName: 'infrastructure_has_supermarket' },
  ShoppingArea: { name: 'Торговая зона', jqParamName: 'infrastructure_has_shopping_area' },
  FitnessCentre: { name: 'Фитнес-центр', jqParamName: 'infrastructure_has_fitness_centre' },
  Studio: { name: 'Фотосалон', jqParamName: 'infrastructure_has_studio' },
  CentralReception: { name: 'Центральная рецепция', jqParamName: 'infrastructure_has_central_reception' },
};

const params: Array<TInfrastructureParam[]> = [
  [
    TInfrastructureParams.CarWash,
    TInfrastructureParams.CarService,
    TInfrastructureParams.Pharmacy,
    TInfrastructureParams.ClothesStudio,
    TInfrastructureParams.ATM,
    TInfrastructureParams.Pool,
    TInfrastructureParams.Buffet,
    TInfrastructureParams.WarehouseComplex,
    TInfrastructureParams.Hotel,
  ],
  [
    TInfrastructureParams.Cafe,
    TInfrastructureParams.Cinema,
    TInfrastructureParams.ConferenceRoom,
    TInfrastructureParams.MedicalCenter,
    TInfrastructureParams.Minimarket,
    TInfrastructureParams.NotaryOffice,
    TInfrastructureParams.Department,
    TInfrastructureParams.Park,
    TInfrastructureParams.Restaraunt,
  ],
  [
    TInfrastructureParams.BeautyShop,
    TInfrastructureParams.Warehouse,
    TInfrastructureParams.Canteen,
    TInfrastructureParams.Supermarket,
    TInfrastructureParams.ShoppingArea,
    TInfrastructureParams.FitnessCentre,
    TInfrastructureParams.Studio,
    TInfrastructureParams.CentralReception,
  ],
];

export const Infrastructure: React.StatelessComponent<Object> = () => (
  <Row title="Инфраструктура">
    <ColumnsContainer>
      {params.map((paramsColumn, index) => (
        <Column key={String(index)}>
          {paramsColumn.map(param => {
            const InfrastructureParam = getCheckboxParam(
              param.name,
              param.jqParamName,
              getInfrastructureParamChangedAction(param.jqParamName),
              style['checkbox'],
            );

            return <InfrastructureParam key={param.jqParamName} />;
          })}
        </Column>
      ))}
    </ColumnsContainer>
  </Row>
);
